export enum STEPS {
  LANCAMENTO = 0,
  ACABARAM = 1,
  PROMOCAO = 2
}
